import { render, staticRenderFns } from "./color.vue?vue&type=template&id=3c120d30&scoped=true&lang=pug&"
import script from "./color.vue?vue&type=script&lang=js&"
export * from "./color.vue?vue&type=script&lang=js&"
import style0 from "./color.vue?vue&type=style&index=0&id=3c120d30&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c120d30",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('3c120d30', component.options)
    } else {
      api.reload('3c120d30', component.options)
    }
    module.hot.accept("./color.vue?vue&type=template&id=3c120d30&scoped=true&lang=pug&", function () {
      api.rerender('3c120d30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form_element/option_selector/items/color.vue"
export default component.exports